import { render, staticRenderFns } from "./CarrierUpload.vue?vue&type=template&id=5016ca2f&scoped=true"
import script from "./CarrierUpload.vue?vue&type=script&lang=js"
export * from "./CarrierUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016ca2f",
  null
  
)

export default component.exports